import { connect } from 'react-redux';

import { prepareFilter } from 'libs/common';
import { GridContainer } from 'libs/ui';
import { Controller } from 'libs/control';
import CashboxFilter from './Filter';
import { CashboxGrid } from './Grid';
import { getRequestParams, addOperations, clearEntries, setSortParams, setOffset, setCount, setSumm } from 'store/ducks/models/cashboxOperations';
import { setScroll } from 'store/ducks/interface/cashboxOperationsGrid';

export const Operations = (props) => {
  const prepareParams = (data) => {
    return prepareFilter(props.getRequestParams(data));
  };

  return (
    <GridContainer>
      <Controller
        type="payment"
        filterName="cashboxOperationsFilter"
        gridFilter={CashboxFilter}
        grid={CashboxGrid}
        entries={props.operations}
        offset={props.offset}
        interface={props.interface}
        count={props.count}
        summ={props.summ}
        sortParams={props.sortParams}
        terminalList={props.terminalList}
        getRequestParams={prepareParams}
        addEntries={props.addOperations}
        clearEntries={props.clearEntries}
        setOffset={props.setOffset}
        setSumm={props.setSumm}
        setSortParams={props.setSortParams}
        setCount={props.setCount}
        setScroll={props.setScroll}
      />
    </GridContainer>
  );
};

const mapStateToProps = (store) => {
  return {
    operations: store.cashboxOperations.operations,
    offset: store.cashboxOperations.offset,
    count: store.cashboxOperations.count,
    summ: store.cashboxOperations.summ,
    sortParams: store.cashboxOperations.sortParams,
    terminalList: store.cashboxOperations.terminalList,
    interface: store.cashboxOperationsGrid,
  };
};

export default connect(mapStateToProps, {
  setScroll,
  getRequestParams,
  addOperations,
  clearEntries,
  setSortParams,
  setOffset,
  setCount,
  setSumm,
})(Operations);
